<script setup>
import '@campact/camper/core/CmprFormControl.css';
import { dispatchCmprInputFocus } from '../javascripts/piwik_web_analytics';

const model = defineModel({ type: String });
</script>

<template>
  <input
    v-model="model"
    class="cmpr-form-control"
    @focus="dispatchCmprInputFocus($event)"
  >
</template>
